import React, { useMemo } from "react";
import { type FormikFormChildProps } from "../FormikForm/FormikFormWrapperForJetpackConfig";
import { type Config } from "kadow-jetpack-model";
import { FieldArray, type FormikErrors } from "formik";

import GiftForm from "../../../17_JetpackOnboarding/components/GiftSelector/GiftForm";
import KC_Card from "../../../../designsystem/KC_Card/KC_Card";
import KC_Card_Dashed from "../../../../designsystem/KC_Card/KC_Card_Dashed";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../../../designsystem/ds_commons";
import { tt } from "../../../../utils/i18n/i18n";
import KC_Padder from "../../../../designsystem/KC_Padder/KC_Padder";
import { useAccountToDisplaySelector } from "../../../../redux/actions/user";
import TSUtils from "../../../../utils/helpers/TSUtils";

import { buildBaseGift } from "../../../../utils/helpers/buildBaseGift";
import { KC_PaddingEnum } from "../../../../designsystem/KC_Card/component/model/KC_PaddingEnum";
import KC_Heading3 from "../../../../designsystem/typography/KC-Heading/KC_Heading3";

const JetpackGiftConfig = (
  props: FormikFormChildProps & {
    errors: FormikErrors<Config>;
  }
) => {
  const { accountToDisplay } = useAccountToDisplaySelector();

  const renderAddGift = () => {
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center gap-sm add-gift-btn">
        <FontAwesomeIcon icon={faPlus} />
        <KC_UIText weight={KC_Weights.bold} text={tt("jp_add_gift_btn_text")} />
      </div>
    );
  };

  const showAddButton = useMemo(() => {
    if (!props.config.prizes) {
      return true;
    }
    return !props.config.prizes?.length || props.config.prizes?.length < 8;
  }, [props.config]);

  const hasAdvancedCouponOptions = useMemo(() => {
    return accountToDisplay?.saasFeatures?.adc || false;
  }, [accountToDisplay?.saasFeatures?.adc]);

  return (
    <div
      id="gift-cards-container"
      className="d-flex st-gap flex-column pt-4 main-gift-config dashboard-v2"
    >
      <div className="px-4 pt-4">
        <KC_Heading3 text={tt("prizes_configurator_my_prizes")} />
      </div>
      <FieldArray name="prizes">
        {(formikArrayFns) => (
          <div className="w-100 d-flex flex-column st-gap px-4 align-items-center">
            <div className="w-100 p-0 m-0 st-gap gift-cards-container">
              {props.config.prizes?.map((_, idx) => {
                return (
                  <KC_Card
                    padding={KC_PaddingEnum.gift}
                    boxShadow={true}
                    className="flex-grow-1"
                    isGiftCard={true}
                    children={
                      <GiftForm
                        prizeIndex={idx}
                        config={props.config}
                        setFieldValue={props.setFieldValue}
                        errors={props.errors}
                        hasAdvancedCouponOptions={hasAdvancedCouponOptions}
                        removeItem={() => formikArrayFns.remove(idx)}
                        addItem={formikArrayFns.replace}
                        setFieldTouched={props.setFieldTouched}
                      />
                    }
                  />
                );
              })}
              {showAddButton && (
                <KC_Card_Dashed
                  id="add-gift"
                  isGift={true}
                  children={renderAddGift()}
                  className="gift-config-inline-add-btn add-gift"
                  onClick={() => {
                    formikArrayFns.push(buildBaseGift(accountToDisplay));

                    const length = props.config.prizes?.length || 0;
                    const modulo = (length + 1) % 2;

                    if (length > 0 && modulo > 0) {
                      setTimeout(() => {
                        TSUtils.scrollTo(
                          document.getElementById("k-main-right"),
                          document.getElementById(`gift-form-${length}`)
                        );
                      }, 300);
                    }
                  }}
                />
              )}
            </div>
          </div>
        )}
      </FieldArray>
      <KC_Padder />
    </div>
  );
};

export default JetpackGiftConfig;
